import React from 'react';

const PCMPopup = ({ isOpen, onClose, data, onFillFromTab, onSendCopy }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">PCM Not Consented</h2>
        <p className="text-xl text-gray-600 mb-6">
          Patient: <span className="text-xl font-medium">{data.name}</span>
        </p>

        <div className="space-y-3">
          <button
            onClick={() => {
              onFillFromTab();
              onClose();
            }}
            className="w-full px-4 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200 shadow-md hover:shadow-lg"
          >
            <i className="fas fa-pen-fancy mr-2"></i>
            Fill from Tab
          </button>
          <button
            onClick={() => {
              onSendCopy();
              onClose();
            }}
            className="w-full px-4 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200 shadow-md hover:shadow-lg"
          >
            <i className="fas fa-envelope mr-2"></i>
            Send a Copy to Patient
          </button>
        </div>

        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2.5 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 transition-colors duration-200 font-medium"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PCMPopup;
